<template>
  <div class="news">
    <Head :index="'10'"></Head>
    <div class="catalogue">
      <div class="nav">栏目导航</div>
      <ul class="nav-list">
        <li
          class="nav-item"
          :class="{ active: selectedType === category.id }"
          v-for="category in categories"
          :key="category.id"
          @click="handleCategoryClick(category.id)"
        >
          {{ category.name }}
        </li>
      </ul>
    </div>
    <div class="content">
      <!-- 栏目介绍 -->
      <div class="introduction">
        <h3>{{ currentCategory.description }}</h3>
      </div>

      <!-- 添加按钮 -->
      <div v-if="showAddButton" class="add-button">
        <button class="primary-btn" @click="handleAdd()">添加新内容</button>
      </div>

      <!-- 数据表格 -->
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 50%">标题</th>
              <th style="width: 15%">时间</th>
              <th style="width: 10%">状态</th>
              <th style="width: 25%">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.id">
              <td>{{ item.title }}</td>
              <td>{{ item.createTime || '-' }}</td>
              <td>
                <span :class="item.verify == 1 ? 'status-pass' : 'status-pending'">
                  {{ item.verify == 1 ? '已审核' : '待审核' }}
                </span>
              </td>
              <td class="operation">
                <button class="text-btn" @click="handleView(item)">查看</button>
                <button class="text-btn edit" @click="handleEdit(item)">编辑</button>
                <button class="text-btn danger" @click="handleDelete(item)">删除</button>
              </td>
            </tr>
            <tr v-if="list.length === 0">
              <td colspan="4" class="empty-tip">暂无数据</td>
            </tr>
          </tbody>
        </table>

        <!-- 分页组件 -->
        <div class="pagination">
          <span>第 {{ page }} 页 / 共 {{ totalPage }} 页（共 {{ total }} 条）</span>
          <button @click="changePage(1)" :disabled="page === 1">首页</button>
          <button @click="changePage(page - 1)" :disabled="page === 1">上一页</button>
          <button @click="changePage(page + 1)" :disabled="page === totalPage">下一页</button>
          <button @click="changePage(totalPage)" :disabled="page === totalPage">末页</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogForm" width="80%" style="margin-top:-6vh" :title="editingId ? '编辑新闻' : '添加新闻'">
      <div>
        <el-form ref="newsForm" label-width="70px" :model="newsForm">
          <el-form-item label="标题" prop="title">
            <el-input type="text" placeholder="请输入标题" autocomplete="off" v-model="newsForm.title"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content">
            <vue-ueditor-wrap
              v-model="newsForm.content"
              editor-id="editor6"
              :config="editorConfig"
              :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
            />
          </el-form-item>
          <el-form-item label="审核">
            <el-radio-group v-model="newsForm.verify">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm()" :loading="submitting">{{ editingId ? '保存' : '确定' }}</el-button>
            <el-button @click="dialogForm = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogDetail" width="70%" style="margin-top:-6vh" title="新闻详情">
      <div v-if="detailData" class="detail-wrap">
        <h2 class="detail-title">{{ detailData.title }}</h2>
        <div class="detail-meta">
          <span v-if="detailData.createTime">时间：{{ detailData.createTime }}</span>
          <span v-if="detailData.verify != null">
            状态：{{ detailData.verify == 1 ? '已审核' : '待审核' }}
          </span>
        </div>
        <div class="detail-content" v-html="detailData.content"></div>
      </div>
      <template #footer>
        <el-button @click="dialogDetail = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Head from "@/components/header.vue";
import api from "@/request/api";
import VueUeditorWrap from "vue-ueditor-wrap";
import base from "@/request/base";
export default {
  data() {
    return {
      editorConfig: {
        serverUrl: base.baseURL + 'news/upload',
        UEDITOR_HOME_URL: '/static/UEditor/',
        UEDITOR_CORS_URL: '/static/UEditor/',
        initialFrameHeight: 400,
      },
      newsForm: {
        title: "",
        content: "",
        verify: 0
      },
      editingId: null,
      submitting: false,
      categories: [
        { id: 1, name: '家族新闻和公告', description: '发布关于家族的重大新闻、重要公告和通知。' },
        { id: 2, name: '家族成就和荣誉', description: '展示家族成员在个人事业、学术研究、社会贡献等方面的成就和获得的荣誉。' },
        { id: 3, name: '家族各分支情况', description: '介绍各分支迁徙时间、始迁(祖)人、成员数量、文化结构、分布地区、主要人物、经济状况等。' },
        { id: 4, name: '家族活动和聚会', description: '记录家族组织的各种活动，如祭祀活动、团聚、庆祝活动、公益活动等，以及这些活动的文字、照片、视频。' },
        { id: 5, name: '家族成员的动态', description: '分享家族成员的生活点滴、旅行见闻、学习心得等，增进家族成员之间的了解和亲近感。' },
        { id: 6, name: '家族文化的传承', description: '介绍家族历史、祖先事迹、家族故事、家族传统和价值观，家规、家训教育等。' },
        { id: 7, name: '家族教育和发展', description: '探讨家族对下一代教育的重视，包括家庭教育理念、教育资源的利用以及家族成员的职业发展支持。' },
        { id: 8, name: '家族之社会责任', description: '展示家族及其成员在社会责任方面的努力和贡献，如扶贫救困、慈善捐赠、风义勇为等。' },
        { id: 9, name: '家族的财产管理', description: '涉及家族财富的管理和传承，包括家族捐助、集资款(物)的使用、管理情况公示，以及家族有形与无形资产的传承与保护。' },
      ],
      permission: -1,
      selectedType: 1,
      currentCategory: {},
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      dialogForm: false,
      dialogDetail: false,
      detailData: null,
    };
  },
  components: {
    Head,
    VueUeditorWrap
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.limit) || 1;
    },
    showAddButton() {
      if (this.permission === 0) {
        return true;
      } else if (this.permission > 0) {
        return [3, 4, 8].includes(this.selectedType);
      } else {
        return this.selectedType === 5;
      }
    }
  },
  mounted() {
    this.currentCategory = this.categories.find(c => c.id === this.selectedType);
    this.loadData();
    api.getpermission(localStorage.getItem('fid'))
      .then(res => {
        this.permission = res.data;
      })
      .catch(err => {
        console.error('权限获取失败', err);
        this.permission = -1;
      });
  },
  methods: {
    handleCategoryClick(type) {
      this.selectedType = type;
      this.currentCategory = this.categories.find(c => c.id === type);
      this.page = 1;
      this.loadData();
    },
    loadData() {
      const params = {
        type: this.selectedType,
        page: this.page,
        limit: this.limit,
        fid: localStorage.getItem('fid')
      };
      api.getnews(params)
        .then(res => {
          if (res.code === 0) {
            this.list = res.data || [];
            this.total = res.count || 0;
          } else {
            this.list = [];
            this.total = 0;
          }
        })
        .catch(err => {
          console.error('数据加载失败', err);
          this.list = [];
          this.total = 0;
        });
    },
    changePage(newPage) {
      if (newPage < 1 || newPage > this.totalPage) return;
      this.page = newPage;
      this.loadData();
    },
    handleAdd() {
      this.editingId = null;
      this.newsForm = { title: "", content: "", verify: 0 };
      this.dialogForm = true;
    },
    handleView(item) {
      this.detailData = null;
      api.newsDetail({id: item.id, fid: localStorage.getItem('fid')}).then(res => {
        if (res.code === 0) {
          this.detailData = res.data;
          this.dialogDetail = true;
        } else {
          this.$message({ message: res.msg || '获取详情失败', type: 'warning' });
        }
      }).catch(() => {
        this.$message({ message: '获取详情失败', type: 'error' });
      });
    },
    handleEdit(item) {
      this.editingId = item.id;
      this.newsForm = { title: "", content: "", verify: 0 };
      api.newsDetail(item.id).then(res => {
        if (res.code === 0) {
          this.newsForm = {
            title: res.data.title || "",
            content: res.data.content || "",
            verify: res.data.verify != null ? res.data.verify : 0
          };
          this.dialogForm = true;
        } else {
          this.$message({ message: res.msg || '获取详情失败', type: 'warning' });
        }
      }).catch(() => {
        this.$message({ message: '获取详情失败', type: 'error' });
      });
    },
    handleDelete(item) {
      this.$confirm('确定删除"' + item.title + '"?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.newsDelete({id: item.id, fid: localStorage.getItem('fid')}).then(res => {
          if (res.code === 0) {
            this.$message({ message: '删除成功', type: 'success' });
            this.loadData();
          } else {
            this.$message({ message: res.msg || '删除失败', type: 'warning' });
          }
        }).catch(() => {
          this.$message({ message: '删除失败', type: 'error' });
        });
      }).catch(() => {});
    },
    submitForm() {
      if (!this.newsForm.title.trim()) {
        this.$message({ message: '请输入标题', type: 'warning' });
        return;
      }
      this.submitting = true;
      const data = {
        title: this.newsForm.title,
        content: this.newsForm.content,
        classid: this.selectedType,
        verify: this.newsForm.verify,
        fid: localStorage.getItem('fid')
      };
      const request = this.editingId
        ? api.newsUpdate({ id: this.editingId, title: data.title, content: data.content, classid: data.classid, verify: data.verify, fid: data.fid })
        : api.newsAdd(data);

      request.then(res => {
        this.submitting = false;
        if (res.code === 0) {
          this.$message({
            message: this.editingId ? '修改成功' : '添加成功',
            type: 'success'
          });
          this.dialogForm = false;
          this.loadData();
        } else {
          this.$message({ message: res.msg || '操作失败', type: 'warning' });
        }
      }).catch(() => {
        this.submitting = false;
        this.$message({ message: '操作失败', type: 'error' });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.news {
  overflow: hidden;
  height: 100%;
  background: #f8f9fa;

  .catalogue {
    width: 200px;
    height: 100%;
    float: left;
    padding: 0;
    box-sizing: border-box;
    border-right: 1px solid #ebedf0;
    overflow: auto;
    position: relative;
    z-index: 1;
    background: #fff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.03);

    .nav {
      font-size: 16px;
      font-weight: 600;
      background: #ffece4;
      color: #333;
      padding: 15px 30px;
      position: relative;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 30px;
        right: 30px;
        height: 2px;
        background: linear-gradient(90deg, #e04428 20%, #ffece4 100%);
      }
    }

    .nav-list {
      padding-left: 0;
      list-style: none;
      margin-top: 10px;

      .nav-item {
        padding: 12px 30px;
        margin: 6px 0;
        border-radius: 0 20px 20px 0;
        font-size: 14px;
        color: #666;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        display: flex;
        align-items: center;
        line-height: 1.5;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 0;
          background: #e04428;
          transition: all 0.3s;
        }

        &:hover, &.active {
          color: #e04428;
          background: #fff5f3;
          transform: translateX(8px);

          &::before {
            height: 60%;
          }
        }

        &:active {
          transform: translateX(5px);
          transition-duration: 0.1s;
        }
      }

      .nav-item + .nav-item {
        border-top: 1px dashed #ffd9d1;
      }
    }
  }

  .content {
    margin-left: 200px;
    padding: 20px 30px;
    box-sizing: border-box;
    height: 100%;
    overflow: auto;

    .introduction {
      margin-bottom: 20px;
      padding: 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

    .add-button {
      margin: 20px 0;
      text-align: right;
    }

    .primary-btn {
      padding: 8px 16px;
      border: none;
      border-radius: 4px;
      background-color: #e04428;
      color: white;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #c93e25;
      }
    }

    .table-container {
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);

      .data-table {
        width: 100%;
        border-collapse: collapse;

        th, td {
          padding: 12px 15px;
          text-align: left;
          border-bottom: 1px solid #ebedf0;
        }

        th {
          background: #f8f9fa;
          color: #2c3e50;
          font-weight: 600;
        }

        .operation {
          white-space: nowrap;
        }

        .text-btn {
          border: none;
          background: none;
          cursor: pointer;
          padding: 4px 10px;
          font-size: 13px;
          color: #409eff;
          border-radius: 4px;
          transition: background 0.2s;

          &:hover {
            background: #ecf5ff;
          }

          &.edit {
            color: #67c23a;
            &:hover { background: #f0f9eb; }
          }

          &.danger {
            color: #f56c6c;
            &:hover { background: #fef0f0; }
          }
        }

        .status-pass {
          color: #67c23a;
          font-size: 12px;
          padding: 2px 8px;
          background: #f0f9eb;
          border-radius: 4px;
        }

        .status-pending {
          color: #e6a23c;
          font-size: 12px;
          padding: 2px 8px;
          background: #fdf6ec;
          border-radius: 4px;
        }

        .empty-tip {
          text-align: center;
          color: #999;
          padding: 40px 0;
        }
      }

      .pagination {
        margin-top: 20px;
        text-align: right;
        color: #5a5e66;

        button {
          margin-left: 10px;
          padding: 6px 12px;
          border: 1px solid #ebedf0;
          border-radius: 4px;
          background: #fff;
          cursor: pointer;

          &:disabled {
            color: #c0c4cc;
            cursor: not-allowed;
            border-color: #c0c4cc;
          }
        }
      }
    }
  }
}

.detail-wrap {
  padding: 10px 0;

  .detail-title {
    text-align: center;
    font-size: 22px;
    color: #333;
    margin-bottom: 15px;
  }

  .detail-meta {
    text-align: center;
    color: #999;
    font-size: 13px;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebedf0;

    span + span {
      margin-left: 20px;
    }
  }

  .detail-content {
    font-size: 15px;
    line-height: 1.8;
    color: #333;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/news.vue